import SecondaryNav from "@/components/feature/SecondaryNav";
import Footer from "@/components/feature/Footer";

interface SiteLayoutProps {
  children: React.ReactNode;
  active?: string;
  noFooterTop?: boolean;
}

export default function SiteLayout({ children, active, noFooterTop = false }: SiteLayoutProps) {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950 flex flex-col">
      <SecondaryNav active={active} />
      <main className="flex-1 w-full">{children}</main>
      <Footer compact={noFooterTop} />
    </div>
  );
}